import { lazy } from "react";
import Loadable from "../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../../constants/enums";
import { REACT_APP_NAV_ROUTES } from "../../../router/AppNavigation";

const ExternalLeadStatusLifeCycle = Loadable(
  lazy(() =>
    import("./ExternalLeadStatusLifeCycle").then(({ ExternalLeadStatusLifeCycle }) => ({
      default: ExternalLeadStatusLifeCycle,
    }))
  )
);

const ExternalLeadMasterStatusTable = Loadable(
  lazy(() =>
    import("./ExternalLeadMasterStatusTable").then(({ ExternalLeadMasterStatusTable }) => ({
      default: ExternalLeadMasterStatusTable,
    }))
  )
);

export const externalLeadLifeCycleRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.OrganizationSettings.ExternalLeadLifecycle,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.EXTERNAL_STATUS_LIFE_CYCLE]}>
        <ExternalLeadStatusLifeCycle isEnr={false} />
      </AuthorizedRoute>
    ),
  },
  {
    path: REACT_APP_NAV_ROUTES.ExternalLeadMasterStatus,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.EXTERNAL_LEAD_MASTER_STATUS]}>
        <ExternalLeadMasterStatusTable isEnr={true} />
      </AuthorizedRoute>
    ),
  },
];
